import React from "react";
import Heading from "../../common/Heading";
import MyReviewItem from "./MyReviewItem";

import { Container, ReviewBox } from "./review_element";
import { reviewSection } from "../../data";

const Reviews = () => {
  return (
    <Container id="reviews">
      <Heading
        heading="What my clients say about me and my work"
        subheading=""
        headingFontSize="2rem"
      />

      {/* <Fade right cascade duration={1000}> */}
      <ReviewBox>
        {reviewSection.map((review, i) => {
          return (
            <MyReviewItem
              key={i}
              index={i}
              heading={review.name}
              subheading={review.review}
            />
          );
        })}
      </ReviewBox>
      {/* </Fade> */}
    </Container>
  );
};

export default Reviews;
